<template>
  <div class="photoTab">
    <div class="scale-selection">
      <span class="scale-selection-title">
        {{ $t('chooseScale') }}
      </span>
      <div class="radio">
        <label class="custom-radio">
          <input
            v-model="scale"
            type="radio"
            value="1/1"
            @change="onScaleChange"
          />
          1/1
        </label>
      </div>
      <div class="radio">
        <label v-if="isGeneral" class="custom-radio">
          <input
            v-model="scale"
            type="radio"
            value="2/1"
            @change="onScaleChange"
          />
          2/1
        </label>
      </div>
      <div class="radio">
        <label v-if="!isGeneral" class="custom-radio">
          <input
            v-model="scale"
            type="radio"
            value="3/2"
            @change="onScaleChange"
          />
          3/2
        </label>
      </div>
    </div>
    <div class="photoTab__container">
      <div class="options__input-photo">
        <span class="options__input-photo-title">
          {{ isGeneral ? $t('logoPhoto') : $t('advertPhoto') }}
        </span>
        <FormKit
          :classes="{
            input: 'photoInput',
            inner: 'photoInputInner'
          }"
          :name="'logo'"
          type="file"
          accept=".png"
          validation="required"
          @input="onFileChange"
        />
      </div>
      <img class="existingPhoto" :src="existingPhoto" alt="" />
    </div>
    <cropper
      v-if="imageSrc"
      ref="cropper"
      class="cropper"
      :src="imageSrc"
      :stencil-props="stencilProps"
      :transform="transform"
      @change="onCrop"
    />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

@Options({
  name: 'PhotoTab',
  props: ['existingPhoto'],
  components: {
    Cropper
  },
  data() {
    return {
      scale: '1/1',
      imageSrc: '',
      stencilProps: {
        aspectRatio: 1
      },
      transform: null
    };
  },
  computed: {
    isGeneral() {
      return this.$route.name === 'General';
    }
  },
  methods: {
    /* eslint-disable */
    onFileChange(event: any) {
      const input = event[0]?.file;

      if (input) {
        const file = input;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageSrc = e.target?.result as string;
          this.$emit('update:imageSrc', this.imageSrc);
        };
        reader.readAsDataURL(file);
      }
    },
    onScaleChange() {
      switch (this.scale) {
        case '1/1':
          this.stencilProps = { ...this.stencilProps, aspectRatio: 1 };
          break;
        case '2/1':
          this.stencilProps = { ...this.stencilProps, aspectRatio: 2 };
          break;
        case '3/2':
          this.stencilProps = { ...this.stencilProps, aspectRatio: 3 / 2 };
          break;
      }
      this.$nextTick(() => {
        const cropper = this.$refs.cropper as any;
        cropper?.update();
      });
    },
    onCrop({ coordinates, canvas }: { coordinates: any; canvas: any }) {
      this.coordinates = coordinates;
      this.image = canvas.toDataURL();

      this.$emit('update:imageSrc', this.image);
    }
  }
})
export default class PhotoTab extends Vue {}
</script>

<style lang="scss">
.photoTab {
  .scale-selection {
    .scale-selection-title {
      margin-right: 14px;
    }
    .radio {
      position: relative;
      display: inline-block;
      height: 16px;
      min-width: 16px;
      margin-left: 15px;
      .custom-radio {
        display: flex;
        align-items: center;
        height: 100%;
        width: auto;
        font-size: $fourteenSize;
        cursor: pointer;
        input[type='radio'] {
          width: 16px;
          height: 16px;
          margin-left: 8px;
          border-radius: 50%;
          transition: box-shadow 0.3s ease;
          appearance: none;
          cursor: pointer;
          &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            display: block;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            border: 1px solid $checkbox-border;
            background: $white;
            transition: background 0.1s linear, border 0.1s linear;
            z-index: 0;
          }
          &:after {
            content: '';
            position: absolute;
            top: 4.5px;
            left: 5px;
            width: 8px;
            height: 8px;
            z-index: 2;
            opacity: 1;
            border-radius: 5px;
            background-color: $white;
            transition: opacity 0.1s linear;
          }
          &:checked:before {
            background: $main-green;
            border: 1px solid $main-green;
          }
        }
      }
    }
  }
  .photoTab__container {
    display: flex;
    align-items: flex-end;
    .options__input-photo {
      display: flex;
      align-items: center;
      height: 50px;
      width: 585px;
      .options__input-photo-title {
        margin-right: 24px;
      }
      .formkit-inner {
        border: none;
        &.photoInputInner {
          position: relative;
          .photoInput {
            width: 84px;
            opacity: 0;
            cursor: pointer;
          }
          &::before {
            position: absolute;
            content: 'Upload';
            top: 0;
            left: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 83px;
            height: 48px;
            border: 1px solid #000;
            border-radius: 8px 0px 0px 8px;
            cursor: pointer;
          }
          &::after {
            position: absolute;
            content: '';
            top: 0;
            left: 84.8px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            width: 377px;
            height: 48px;
            padding-left: 16px;
            color: #7e7e7e;
            border: 1px solid #e5e5e5;
            border-radius: 0 8px 8px 0;
            border-left: none;
          }
          .formkit-file-list {
            position: absolute;
            top: 0;
            left: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 48px;
            margin-left: 83px;
            border-radius: 0 4px 4px 0;
            border-left: none;
            color: #000000de;
            .formkit-file-item {
              padding-left: 16px;
              .formkit-file-remove {
                display: none;
              }
            }
          }
        }
      }
    }
    .existingPhoto {
      margin-left: 100px;
      height: 100px;
    }
  }
  .vue-advanced-cropper {
    &.cropper {
      max-width: 80vw;
      max-height: 300px;
      margin-top: 30px;
      background: $white;
      .vue-advanced-cropper__stretcher {
        height: 300px;
        z-index: -1;
      }
    }
  }
}

.formkit-no-files {
  display: none;
  cursor: default;
}
</style>
